import React from 'react';

interface ScopeModeBadgeProps {
  mode: 'local' | 'mixed' | 'portal_enforced';
}

const labels: Record<ScopeModeBadgeProps['mode'], string> = {
  local: 'Local mode',
  mixed: 'Mixed mode',
  portal_enforced: 'Portal enforced'
};

const descriptions: Record<ScopeModeBadgeProps['mode'], string> = {
  local: 'Each SPFx installation manages its own Scopes. The Portal sees them but does not push a tenant default.',
  mixed: 'Installations may use a Portal-published Scope or keep a local one.',
  portal_enforced: 'Every installation uses the Portal-published Scope. Local editing is disabled.'
};

export const ScopeModeBadge: React.FC<ScopeModeBadgeProps> = ({ mode }) => {
  return (
    <span
      className={`scopes-mode-badge mode-${mode.replace(/_/g, '-')}`}
      title={descriptions[mode]}
    >
      <span className="dot" aria-hidden="true" />
      {labels[mode]}
    </span>
  );
};

export default ScopeModeBadge;
